import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { components as selectComponents } from "react-select";
import AsyncSelect from "react-select/lib/Async";
import debounce from "lodash.debounce";

import { fetchTagsSuggestions } from "Thunks";

import { selectStyle } from "./ReactSelectStyle";

import _ from "i18n";

const Input = props => {
  if (props.isHidden) {
    return <selectComponents.Input {...props} />;
  }
  return (
    <div>
      <selectComponents.Input {...props} />
    </div>
  );
};

const Option = props => {
  const { children, ...rest } = props;

  return <selectComponents.Option {...rest} children={children} />;
};

class TagSelect extends PureComponent {
  _loadSuggestions = (query, callback) => {
    const { fetchTagsSuggestions, lng, filterNotIn } = this.props;
    const nameAttr = `name${lng.charAt(0).toUpperCase() + lng.slice(1)}`;
    fetchTagsSuggestions({
      name: query,
      nameAttr: nameAttr,
      notIn: filterNotIn
    }).then(result => callback(result.value.data.data));
  };

  loadSuggestions = debounce(this._loadSuggestions, 300);

  render() {
    const { onChange, lng, tag } = this.props;

    const lngs = ["Fr", "En", "Nl"];
    const nameAttr = `name${lng.charAt(0).toUpperCase() + lng.slice(1)}`;

    return (
      <AsyncSelect
        styles={selectStyle()}
        value={tag ? [tag] : null}
        onChange={onChange}
        loadOptions={this.loadSuggestions}
        defaultOptions={false}
        //isMulti
        getOptionLabel={option => {
          if (option[nameAttr]) {
            return option[nameAttr];
          }
          for (let i = 0; i < 3; i++) {
            if (lngs[i] !== lng) {
              let helpAttr = `name${lngs[i].charAt(0).toUpperCase() +
                lngs[i].slice(1)}`;
              if (option[helpAttr]) {
                return option[helpAttr];
              }
            }
          }
          return null;
        }}
        getOptionValue={option => option.id}
        components={{ Option, Input }}
        //placeholder={_("Select tags...")}
      />
    );
  }
}

// Connected Component
const mapStateToProps = (state, ownProps) => ({
  filterNotIn: state.trees.filterNotIn
});

const mapDispatchToProps = dispatch => ({
  fetchTagsSuggestions: options => dispatch(fetchTagsSuggestions(options))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TagSelect);



// WEBPACK FOOTER //
// ./src/components/Common/TagSelect/index.js